import { css } from 'styled-components';

import type { CSSProperties } from 'react';

function camelToKebabCase(property: string): string {
  return property.replace(/([A-Z])/g, '-$1').toLowerCase();
}

function formatCSSValue(value: string | number | undefined | null): string {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value === 'number') {
    // Add 'px' unit to numeric values that typically need units
    // but allow unitless values for properties that don't need them
    return value === 0 ? '0' : `${value}px`;
  }
  return String(value);
}

export function applyCSSOverrides(
  overrides?: CSSProperties | Record<string, string | number> | null,
) {
  // Return empty css if no overrides provided
  if (!overrides || typeof overrides !== 'object') {
    return css``;
  }

  // Filter out undefined/null values and convert to CSS string
  const cssRules = Object.entries(overrides)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => {
      const cssProperty = camelToKebabCase(key);
      const cssValue = formatCSSValue(value);
      return cssValue ? `${cssProperty}: ${cssValue};` : '';
    })
    .filter(Boolean) // Remove empty strings
    .join('\n');

  return cssRules
    ? css`
        ${cssRules}
      `
    : css``;
}

export function forIPad(content: string): string {
  return `@media only screen and (max-width: 1200px) {
    ${content}
  }`;
}
